import { defineMessages } from 'react-intl';

export const scope = 'cb.components.OrderSummary';

export default defineMessages({
  orderSummaryText: {
    id: `${scope}.orderSummaryText`,
    defaultMessage: 'Order Summary',
  },
  membershipText: {
    id: `${scope}.membershipText`,
    defaultMessage: '{name} Membership',
  },
  taxesText: {
    id: `${scope}.taxesText`,
    defaultMessage: 'Taxes',
  },
  totalText: {
    id: `${scope}.totalText`,
    defaultMessage: 'Total',
  },
});